import React from 'react'

export default function DashboardPage() {
    return (
        <div>DashboardPage ยังไม่ได้เริ่ม</div>
    )
}
